import { Col, DatePicker, Form, Select, Tag } from "antd"
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { useState } from "react";
import { customFormat, customLocalDateFormat, customYearMonthFormat } from "../../../../common/utils/formatDate";

export default function SelectMonthPeriod(props: {setSelectedType: any, defaultValue: string}) {
    
  const [selectedOption, setSelectedOption] = useState(props.defaultValue || 'LAST_2YEARS');
  const [selectedRange, setSelectedRange] = useState(null);

  const handleChange = (value: any) => {
    setSelectedOption(value);
    setSelectedRange(null); 

    if (value !== 'CUSTOM_RANGE' && props.setSelectedType) {
      props.setSelectedType(value); 
    }
  };

  const handleRangeChange = (dates: any) => {    
    setSelectedRange(dates);
    setSelectedOption('CUSTOM_RANGE'); 
    
    if (props.setSelectedType) {
      props.setSelectedType('CUSTOM_RANGE' + dates.map((date: any) => date.format('MM-YYYY'))); 
    }
  };

    return (
        <div className={selectedOption !== (props.defaultValue || 'LAST_2YEARS') ? 'page-filter-control--active' : undefined}>
           <div>
                <Select  bordered={false} 
                    onChange={handleChange}
                    value={selectedOption}
                    style={{ minWidth: '180px', color: selectedOption !== (props.defaultValue || 'LAST_2YEARS') ? '#1b6ef5' : 'steelblue', fontWeight: 'bold', fontSize: '16px', textAlign:'left' }} >

                    <Select.Option value='CURRENT_MONTH'>Mes Actual</Select.Option>
                    <Select.Option value='PREVIOUS_MONTH'>Mes Anterior</Select.Option>                  
                    <Select.Option value='LAST_6MONTHS'>Últimos 6 meses</Select.Option>
                    <Select.Option value='LAST_12MONTHS'>Últimos 12 meses</Select.Option>
                    <Select.Option value='LAST_24MONTHS'>Últimos 24 meses</Select.Option>        
                    <Select.Option value="CUSTOM_RANGE">Rango Personalizado</Select.Option>

                </Select>
            </div> 
        {selectedOption === 'CUSTOM_RANGE' && (

            <div> 
                <DatePicker.RangePicker		
                    picker="month"
                    format={(customYearMonthFormat)}
                    placeholder={['Mes Inicio', 'Mes Final']}
                    size="small"
                    style={{ marginLeft: 10, minWidth: '250px' }}
                    onChange={handleRangeChange}
                    value={selectedRange}/>
            </div> 
        )}
        </div>
    )
}
